module.exports = __webpack_public_path__ + "img/ico_next.f0bc6aeb.svg";